import {gql} from 'apollo-angular';
export const GET_SCHOOL_CLASS_POINTS = gql`
  query GetSchoolClassPoints($classCode: String!) {
    schoolClassPoints(classCode: $classCode)
  }
`;
